import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';

export const useMainStore = defineStore('main', {
  state: () => ({
    user: useStorage('user', null),
    userToken: useStorage('userToken', null),
    usageLimit: useStorage('usageLimit', null),
    usageCount: useStorage('usageCount', null),
    paymentLink: useStorage('paymentLink', null),
    loadedLimitsInfo: useStorage('loadedLimitsInfo', false),
  }),
  actions: {
    setUser(user) {
      const simplifiedUser = {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        photoURL: user.photoURL,
      };
      this.user = simplifiedUser;
      user.getIdToken().then((token) => {
        this.userToken = token;
        return fetch(`${process.env.VUE_APP_DIAGRAM_GENERATION_API_URL}/api/me`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        return response.json();
      }).then((data) => {
        this.usageLimit = data.usage_limit;
        this.usageCount = data.usage_count;
        this.loadedLimitsInfo = true;
        return fetch(
          `${process.env.VUE_APP_DIAGRAM_GENERATION_API_URL}/api/payments`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          }
        );
      }).then((response) => {
        if (response && !response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        return response ? response.json() : null;
      }).then((paymentData) => {
        if (paymentData) {
          this.paymentLink = paymentData;
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    async clearUser() {
      this.user = null;
      this.usageLimit = null;
      this.usageCount = null;
      this.paymentLink = null;
      this.loadedLimitsInfo = false;
    },
    refreshUserData() { }
  },
});

export default useMainStore;